import { ColorMode } from '@/contexts/app-theme/helpers';
import { JsonObject } from '@/lib/helpers';

export class PreferencesModel {
  tail: boolean;
  useBuffer: boolean;
  colorMode: ColorMode;

  constructor(props: JsonObject = {}) {
    const data = props as Record<keyof PreferencesModel, unknown>;
    this.tail = typeof data.tail === 'boolean' ? data.tail : true;
    this.useBuffer = typeof data.useBuffer === 'boolean' ? data.useBuffer : true;
    this.colorMode = (data.colorMode as ColorMode) || 'light';
  }
}
